import { Col, Grid, Row } from 'react-bootstrap'
import { VIEW_DATASET_MEASUREMENT, VIEW_DATASET_PLATESETUP, VIEW_DATASET_SUMMARY } from '../../constants/saxs'
import {
  getDownloadHDF5FramesURL,
  getHPLCOverviewByExperimentId,
  getSaxsExperimentByExperimentId,
  getSaxsExtendedSubtractionsByExperimentId,
  getSaxsHPLCFrame,
} from '../../api/ispyb'

import { CSVFrameToDataSeriesParser1 } from '../../helpers/Saxs/SaxsFrameDataSerieMapper'
import DataCollectionListMenu from '../../components/saxs/DataCollection/DataCollectionListMenu'
import DataCollectionListPanel from '../../components/saxs/DataCollection/DataCollectionListPanel'
import { HPLCSummaryDataParser } from '../../helpers/Saxs/SaxsHPLCDataSerieMapper'
import PropTypes from 'prop-types'
import React from 'react'
import SaxsHPLCSummaryPlot from '../../components/saxs/SaxsHPLCSummaryPlot'
import SaxsHPLCSummaryTable from '../../components/saxs/SaxsHPLCSummaryTable'
import SaxsPlateTable from '../../components/saxs/DataCollection/PlateSetup/SaxsPlatesTable'
import SaxsPlatesPanel from '../../components/saxs/DataCollection/PlateSetup/SaxsPlatesPanel'
import SaxsRequester from './helpers/SaxsRequester'
import SaxsSimplePlot from '../../components/saxs/SaxsSimplePlot'
import cloneDeep from 'lodash/cloneDeep'
import { connect } from 'react-redux'
import find from 'lodash/find'
import { parseDataCollections } from '../../helpers/Saxs/SaxsDataCollectionMapper'
import { parseExperiment } from '../../helpers/Saxs/SaxsExperimentsMapper'

class SaxsDataCollectionsContainer extends React.Component {
  render() {
    return (
      <SaxsRequester
        url={getSaxsExtendedSubtractionsByExperimentId(this.props.user, this.props.proposal, this.props.experimentId)}
        parser={parseDataCollections}
      >
        {dataCollections => {
          if (this.props.experimentType === 'HPLC') {
            return (
              <SaxsHPLCPage
                dataCollections={dataCollections}
                experimentId={this.props.experimentId}
                proposal={this.props.proposal}
                user={this.props.user}
              />
            )
          }
          return (
            <SaxsSampleChangerPage
              dataCollections={dataCollections}
              experimentId={this.props.experimentId}
              proposal={this.props.proposal}
              user={this.props.user}
            />
          )
        }}
      </SaxsRequester>
    )
  }
}

SaxsDataCollectionsContainer.propTypes = {
  /** the selected experiment identifier */
  experimentId: PropTypes.string,
  /** the selected experiment type */
  experimentType: PropTypes.string,
}

class SaxsSampleChangerPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      view: VIEW_DATASET_SUMMARY,
    }
    this.setView = this.setView.bind(this)
  }

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <DataCollectionListMenu setView={this.setView} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            {this.state.view === VIEW_DATASET_SUMMARY || this.state.view === VIEW_DATASET_MEASUREMENT ? (
              <DataCollectionListPanel
                dataCollections={this.props.dataCollections}
                experimentId={this.props.experimentId}
                proposal={this.props.proposal}
                sessionId={this.props.sessionId}
                user={this.props.user}
                view={this.state.view}
              />
            ) : null}

            {this.state.view === VIEW_DATASET_PLATESETUP ? (
              <SaxsRequester
                url={getSaxsExperimentByExperimentId(this.props.user, this.props.proposal, this.props.experimentId)}
                parser={parseExperiment}
              >
                {experiment => (
                  <Grid fluid>
                    <Row>
                      <Col xs={12} md={4}>
                        <SaxsPlatesPanel experiment={experiment[0]} />
                      </Col>
                      <Col xs={12} md={8}>
                        <SaxsPlateTable dataCollections={this.props.dataCollections} />
                      </Col>
                    </Row>
                  </Grid>
                )}
              </SaxsRequester>
            ) : null}
          </Col>
        </Row>
      </Grid>
    )
  }

  /** Change the view */
  setView(view) {
    this.setState({ view: view })
  }
}

class SaxsHPLCPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedFrames: [], // an object with the following structure {frameId: xx; mass: xx, rg:..., I0:..., downloadURL: xx }
    }

    this.addFrameToSelection = this.addFrameToSelection.bind(this)
    this.clearSelectedFrames = this.clearSelectedFrames.bind(this)
    this.getSelectedFrameIds = this.getSelectedFrameIds.bind(this)
  }

  render() {
    return (
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <DataCollectionListPanel
              dataCollections={this.props.dataCollections}
              experimentId={this.props.experimentId}
              proposal={this.props.proposal}
              user={this.props.user}
              view={VIEW_DATASET_SUMMARY}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={6}>
            <SaxsRequester
              url={getHPLCOverviewByExperimentId(this.props.user, this.props.proposal, this.props.experimentId)}
              parser={HPLCSummaryDataParser}
            >
              {HPLCDataSeries => (
                <SaxsHPLCSummaryPlot
                  dataSeries={HPLCDataSeries}
                  divId="SaxsHplcSECFrameDiv"
                  experimentId={this.props.experimentId}
                  onClearSelectionButtonClicked={this.clearSelectedFrames}
                  onPlotPointClicked={this.addFrameToSelection}
                  proposal={this.props.proposal}
                  user={this.props.user}
                />
              )}
            </SaxsRequester>
          </Col>
          <Col xs={12} sm={6}>
            {this.state.selectedFrames.length !== 0 ? (
              <div>
                <SaxsRequester
                  url={getSaxsHPLCFrame(
                    this.props.user,
                    this.props.proposal,
                    this.props.experimentId,
                    this.getSelectedFrameIds()
                  )}
                  parser={data => CSVFrameToDataSeriesParser1(data)}
                >
                  {frameDataSeries => (
                    <SaxsSimplePlot
                      dataSeries={frameDataSeries}
                      divId="SaxsHplcFrameDiv"
                      layout={{
                        title: 'Scattering curves',
                        xaxis: { title: 'q' },
                        yaxis: { title: 'Intensity' },
                        autosize: true,
                      }}
                    />
                  )}
                </SaxsRequester>
                <SaxsHPLCSummaryTable frames={this.state.selectedFrames} />
              </div>
            ) : null}
          </Col>
        </Row>
      </Grid>
    )
  }

  /**
   * Add the frameId in the list of selected frames
   * @param {String} frameId frame identifier
   * @param {String} I0 intensity for that frame
   * @param {String} rg rg for that frame
   * @param {String} mass mass for that frame
   */
  addFrameToSelection(frameId, I0, rg, mass) {
    const isFrameAlreadySelected = () =>
      !!find(this.state.selectedFrames, selectedFrame => selectedFrame.frameId === frameId)

    if (frameId) {
      const selectedFrames = cloneDeep(this.state.selectedFrames)

      if (isFrameAlreadySelected() === false) {
        selectedFrames.push({
          frameId: frameId,
          I0: I0,
          rg: rg,
          mass: mass,
          downloadUrl: getDownloadHDF5FramesURL(
            this.props.user,
            this.props.proposal,
            this.props.experimentId,
            frameId,
            frameId
          ),
        })
      }
      this.setState({ selectedFrames: selectedFrames })
    }
  }

  /**
   * Get frameIds for all selected frames
   * @returns {string} comma separated frameIds. Example: 123,221,440
   */
  getSelectedFrameIds() {
    const frameIds = []
    this.state.selectedFrames.forEach(selectedFrame => {
      frameIds.push(selectedFrame.frameId)
    })

    const join = frameIds.join()
    return join
  }

  /**
   * Clears the selected frames
   */
  clearSelectedFrames() {
    this.setState({ selectedFrames: [] })
  }
}

SaxsSampleChangerPage.propTypes = {
  /** experiemnt identifier */
  experimentId: PropTypes.number,
  /** datacollections */
  dataCollections: PropTypes.array,
}

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(SaxsDataCollectionsContainer)
